import React from "react";
import { useNavigate } from "react-router-dom";
import "./dashboard.scss";

const stats = [
  { label: "Today’s Orders", value: "28", meta: "+6 vs yesterday", icon: "▦" },
  { label: "Today’s Revenue", value: "RM 682.40", meta: "+12.8% today", icon: "RM" },
  { label: "Pending Collection", value: "9", meta: "Collect before 8:00 PM", icon: "↝" },
  { label: "Low / Sold Out Items", value: "4", meta: "Needs attention", icon: "!" },
];

const hasProduct = true;
const productId = 1;

const recentOrders = [
  ["SB-10084", "Channie", "Collectible", "6:30 PM", "RM18.90"],
  ["SB-10083", "Daniel", "Paid", "7:00 PM", "RM12.50"],
  ["SB-10082", "Mei Ling", "Collected", "5:30 PM", "RM9.90"],
  ["SB-10081", "Aiman", "Cancelled", "6:00 PM", "RM15.00"],
];

const DashboardPage = () => {
  const navigate = useNavigate();
  return (
    <div className="dashboard-page">
      <section className="dashboard-hero">
        <div>
          <p className="dashboard-hero__eyebrow">Welcome back, Hikari House</p>
          <h2>Manage orders, pickup readiness, and daily product quantity.</h2>
        </div>
        <div className="dashboard-hero__actions">
          <button type="button" onClick={() => navigate("/vendor/orders")}>View Orders</button>
          <button type="button" onClick={() => navigate(hasProduct ? `/vendor/products/${productId}/edit` : "/vendor/products/1/edit")}>
            {hasProduct ? "Edit Product" : "Edit Product"}
          </button>
        </div>
      </section>

      <section className="dashboard-stats">
        {stats.map((item) => (
          <article className="dashboard-stat" key={item.label}>
            <div className="dashboard-stat__icon">{item.icon}</div>
            <p>{item.label}</p>
            <h3>{item.value}</h3>
            <span>{item.meta}</span>
          </article>
        ))}
      </section>

      <section className="dashboard-grid">
        <article className="dashboard-card dashboard-card--wide">
          <div className="dashboard-card__header">
            <div><h3>Recent Orders</h3><p>Latest guest checkout orders for your outlet.</p></div>
            <button type="button" onClick={() => navigate("/vendor/orders")}>View All</button>
          </div>
          <div className="dashboard-table">
            <div className="dashboard-table__head"><span>Order</span><span>Customer</span><span>Status</span><span>Pickup</span><span>Amount</span></div>
            {recentOrders.map((row) => (
              <button className="dashboard-table__row" type="button" key={row[0]} onClick={() => navigate(`/vendor/orders/${row[0]}`)}>
                {row.map((cell, index) => <span key={index} className={index === 2 ? `status-pill status-pill--${cell.toLowerCase()}` : ""}>{cell}</span>)}
              </button>
            ))}
          </div>
        </article>

        <article className="dashboard-card">
          <h3>Order Status</h3><p>Today’s distribution</p>
          <div className="dashboard-donut"><strong>68%</strong></div>
          <div className="dashboard-summary"><span>Paid</span><b>18</b></div>
          <div className="dashboard-summary"><span>Collectible</span><b>9</b></div>
          <div className="dashboard-summary"><span>Collected</span><b>7</b></div>
        </article>
      </section>
    </div>
  );
};

export default DashboardPage;
